import { tabsAdapter } from '@/store/tabs/adapter.ts';
import type { TabsState } from '@/store/tabs/types.ts';

function deleteTab(state: TabsState, tabId: string) {
  const tab = state.tabs.entities[tabId];

  if (!tab) {
    console.warn(`try to delete tab with id ${tabId} but tab is not found`);
    return;
  }

  const tabIndex = state.tabs.ids.indexOf(tabId);
  tabsAdapter.removeOne(state.tabs, tabId);

  if (state.activeTabId === tabId) {
    const newSelectedTabIndex = Math.min(tabIndex, state.tabs.ids.length - 1);
    state.activeTabId = state.tabs.ids[newSelectedTabIndex] ?? '';
  }
}

export const tabsStateReducers = {
  deleteTab,
} as const;
